import React from 'react';
import { BlogQA } from '../../components/sections/blog/BlogQA';
import { BlogBreadcrumb } from '../../components/sections/blog/BlogBreadcrumb';
export function BlogQAPage() {
  return <section style={{
    background: '#fff',
    minHeight: '100vh',
    paddingTop: '68px'
  }} data-id="element-945" data-mp="7vdqta6q4dqj">
      <BlogBreadcrumb items={[{
      label: 'Alinova',
      to: '/'
    }, {
      label: 'Blog',
      to: '/blog'
    }, {
      label: 'Preguntas & Respuestas'
    }]} data-id="element-946" data-mp="2wu4v9s4r1y6" />
      {/* Las pestañas Artículos / Preguntas & Respuestas viven solo en /blog */}
      <div style={{
      padding: '56px 24px 80px'
    }} data-id="element-947" data-mp="37cvav6dibx78">
        <div style={{
        maxWidth: '1200px',
        margin: '0 auto'
      }} data-id="element-948" data-mp="3latjrw9271fc">
          <BlogQA data-id="element-949" data-mp="3gbgocn44gm15" />
        </div>
      </div>
    </section>;
}